import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_PATHS } from "../../legal/legalPaths";
import "./legal-components.css";

export default function LegalProductNotice({ variant }) {
  if (variant === "nftComic") {
    return (
      <div className="td-legal-micro" role="note">
        <span className="td-legal-micro__icon" aria-hidden>
          <i className="fas fa-scroll" />
        </span>
        <div>
          Includes digital comic access and eligible merchandiser rights subject to the{" "}
          <Link to={LEGAL_PATHS.nftComicMerchLicense}>NFT Comic Merchandiser Terms</Link>.
        </div>
      </div>
    );
  }
  if (variant === "vrRealEstate") {
    return (
      <div className="td-legal-micro" role="note">
        <span className="td-legal-micro__icon" aria-hidden>
          <i className="fas fa-city" />
        </span>
        <div>
          Represents a virtual storefront / location license inside the Treydora / Oshar ecosystem. This is not
          real-world real estate, a deed, equity, or an investment product. See{" "}
          <Link to={LEGAL_PATHS.vrRealEstateTerms}>VR Real Estate NFT Terms</Link>.
        </div>
      </div>
    );
  }
  return null;
}
